import { useEffect, useRef } from "react";

const defaultOptions = { root: null, threshold: 0.1, rootMargin: "150px" };

const useIntersectionObserver = (
	onEndReach: (() => void) | undefined,
	extraDependency: any = undefined,
	{ root, rootMargin, threshold }: IntersectionObserverInit = defaultOptions,
	enabled = true,
) => {
	const refItem = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!refItem.current || !enabled || !onEndReach) return;

		const intersectionObserver = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					onEndReach();
				}
			},
			{ root, threshold, rootMargin },
		);

		intersectionObserver.observe(refItem.current);

		return () => {
			intersectionObserver.disconnect();
		};
	}, [
		refItem,
		onEndReach,
		root,
		threshold,
		rootMargin,
		enabled,
		extraDependency,
	]);

	return refItem;
};

export default useIntersectionObserver;
